import React, { useState, useEffect } from "react";
import { Navbar, Container, Nav } from "react-bootstrap";
import { motion, AnimatePresence } from "framer-motion";
import { HiMenuAlt3, HiX } from "react-icons/hi";

import { FaInstagram, FaFacebookF, FaYoutube } from "react-icons/fa";

import "./header.css";

const Header = () => {
  const [showMenu, setShowMenu] = useState(false);
  const [sticky, setSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setSticky(window.scrollY > 80);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const menuItems = ["About", "Services", "Sanctum", "Blog", "Contact"];

  return (
    <>
      <motion.div
        initial={{ y: -80 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <Navbar className={`main-header ${sticky ? "sticky" : ""}`}>
          <Container fluid>
            {/* Logo */}

            <Navbar.Brand href="/" className="logo">
              <img src="/images/delnaz.png" alt="logo" className="logo-img" />
            </Navbar.Brand>

            {/* Desktop Menu */}

            <Nav className="desktop-menu d-none d-lg-flex mx-auto">
              {menuItems.map((item, index) => (
                <motion.div whileHover={{ y: -2 }} key={index}>
                  <Nav.Link
                    href={`/${item.toLowerCase()}`}
                    className="hover-link"
                  >
                    {item}
                  </Nav.Link>
                </motion.div>
              ))}
            </Nav>

            {/* Social Icons */}

            <div className="social-icons d-none d-lg-flex">
              <a href="https://instagram.com" target="_blank" rel="noreferrer">
                <FaInstagram />
              </a>

              <a href="https://facebook.com" target="_blank" rel="noreferrer">
                <FaFacebookF />
              </a>

              <a href="https://youtube.com" target="_blank" rel="noreferrer">
                <FaYoutube />
              </a>
            </div>

            {/* Mobile Menu */}

            <div
              className="menu-icon d-lg-none"
              onClick={() => setShowMenu(true)}
            >
              <HiMenuAlt3 size={32} />
            </div>
          </Container>
        </Navbar>
      </motion.div>

      <AnimatePresence>
        {showMenu && (
          <motion.div
            className="mobile-menu"
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ duration: 0.4 }}
          >
            <div className="close-icon" onClick={() => setShowMenu(false)}>
              <HiX size={32} />
            </div>

            <ul className="mobile-nav-links">
              {menuItems.map((item, index) => (
                <motion.li
                  key={index}
                  initial={{ opacity: 0, x: 30 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: index * 0.08 }}
                >
                  <a
                    href={`/${item.toLowerCase()}`}
                    onClick={() => setShowMenu(false)}
                  >
                    {item}
                  </a>
                </motion.li>
              ))}
            </ul>

            <div className="mobile-social-icons">
              <a href="https://www.instagram.com/therapist.delnazmedora" target="_blank" rel="noreferrer">
                <FaInstagram />
              </a>

              <a href="https://www.facebook.com/searchingsoulz" target="_blank" rel="noreferrer">
                <FaFacebookF />
              </a>

              <a href="https://www.youtube.com/@DELNAZMEDORA" target="_blank" rel="noreferrer">
                <FaYoutube />
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Header;
